/* The explanation under the bridge. Tokens only; the same type scale and rules as the bridge above it. */

.root {
  margin-top: 16px;
  padding-top: 12px;
  border-top: 1px solid var(--line);
}

.head {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
}

.title {
  margin: 0;
  font-size: var(--t-dense);
  font-weight: 600;
  color: var(--ink);
}

.tag {
  padding: 1px 8px;
  border-radius: var(--radius-ctl);
  border: 1px solid var(--line-2);
  background: var(--panel-2);
  font-size: var(--t-min);
  color: var(--ink-2);
}

.saved {
  margin-top: 8px;
  padding: 7px 10px;
  border-radius: var(--radius-ctl);
  background: var(--panel-2);
  border: 1px solid var(--line);
}

.words {
  margin: 0;
  font-size: var(--t-dense);
  line-height: 1.5;
  color: var(--ink);
  max-width: 92ch;
  white-space: pre-wrap;
}

.meta {
  display: block;
  margin-top: 4px;
  font-size: var(--t-min);
  color: var(--muted);
}

.row {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  align-items: center;
  margin-top: 8px;
}

.note {
  font-size: var(--t-min);
  color: var(--muted);
}

.editor {
  margin-top: 8px;
}

.editor > textarea {
  display: block;
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  padding: 7px 9px;
  border: 1px solid var(--line-2);
  border-radius: var(--radius-ctl);
  background: var(--panel);
  color: var(--ink);
  font-family: var(--font);
  font-size: var(--t-dense);
  line-height: 1.5;
  resize: vertical;
}

.editor > textarea:focus {
  outline: 2px solid var(--focus);
  outline-offset: -1px;
  border-color: var(--focus);
}

.figures {
  list-style: none;
  margin: 8px 0 0;
  padding: 0;
  display: grid;
  gap: 2px;
}

.figure {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  align-items: baseline;
  font-size: var(--t-min);
}

.figureNumber {
  min-width: 7ch;
  font-variant-numeric: lining-nums tabular-nums;
  color: var(--ink-2);
}

.figureLabel {
  color: var(--muted);
}

.button {
  padding: 4px 12px;
  border-radius: var(--radius-ctl);
  border: 1px solid var(--line-2);
  background: var(--panel);
  color: var(--ink);
  font-size: var(--t-min);
  font-weight: 600;
  cursor: pointer;
}

.button:hover {
  background: var(--panel-2);
}

.save {
  padding: 4px 12px;
  border-radius: var(--radius-ctl);
  border: 1px solid var(--accent);
  background: var(--accent);
  color: var(--on-fill);
  font-size: var(--t-min);
  font-weight: 600;
  cursor: pointer;
}

.save:hover:not(:disabled) {
  background: var(--accent-h);
}

.save:disabled {
  border-color: var(--btn-off-bg);
  background: var(--btn-off-bg);
  color: var(--btn-off-ink);
  cursor: not-allowed;
}

.error {
  font-size: var(--t-min);
  color: var(--crit);
}
